import { css } from 'styled-components';

// size settings
export const sizeSmall = css`
    border-radius: 20px;
    border-width: 2px;
    font-size: 14px;
    padding: 0 16px;
`;

export const sizeRegular = css`
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    padding: 2px 14px;
`;

export const sizeLarge = css`
    border-radius: 16px;
    border-width: 2px;
    font-size: 16px;
    font-weight: 600;
    padding: 6px 22px;
`;
